module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page"
  }, [_c('div', {
    staticClass: "login-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "placeholder": "用户名"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "iconfont icon-dingdan"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "",
      "value": "",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "other-option"
  }, [_c('div', {
    staticClass: "left-content"
  }, [(_vm.checked) ? _c('img', {
    attrs: {
      "src": require("assets/checked.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.checked = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.checked) ? _c('img', {
    staticClass: "unchecked-btn",
    attrs: {
      "src": require("assets/unchecked.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.checked = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("记住密码")])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("登录")]), _c('a', [_vm._v("|")]), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goRegister
    }
  }, [_vm._v("注册")])])]), _vm._v(" "), _c('a', {
    staticClass: "form-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n      登 录\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-logo"
  }, [_c('img', {
    attrs: {
      "src": require("assets/logo-login.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e353de1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/login.vue
// module id = 817
// module chunks = 1